import(/* webpackMode: "eager" */ "/app/app/components/pages/product/ProductPagination.js");
import(/* webpackMode: "eager" */ "/app/app/styles/components/pages/special-categories/banner-special-categories.module.scss");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js")